module.exports = __webpack_public_path__ + "img/circle_phone.3dd6fd8d.svg";